var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgVercel = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M0 3a3 3 0 0 1 3-3h6a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#vercel_svg__clip0_93_38529)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "m5.888 3 2.888 5H3z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "vercel_svg__clip0_93_38529"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3 3h5.777v5H3z"
})))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgVercel);
export default ForwardRef;